import React from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import MaxWidth from '../Layout/MaxWidth';
import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import TextContent from '../ui/TextContent';
import { ContentRender } from '../ContentRender/ContentRender';
import { FaqPage } from './FaqPage';
import {
  shouldDisplayNavigation,
  SubNavigation,
  SubPages,
} from './SubPageNavigation';
import { BreadcrumbsWrapper } from '../Layout/BreadcrumbsWrapper';
import BackArrow from '../ui/BackArrow';
import { Above } from '@jetshop/ui/Breakpoints';
import { theme } from '../Theme';

const Wrapper = styled(MaxWidth)`
  padding-bottom: 4rem;
  text-align: center;
  header > ul {
    justify-content: center;
  }
  & .main-content {
    > article {
      > header {
        > h1 {
          margin: 0.5rem 0 2rem !important;
        }
      }
      > .content-wrapper {
        padding-top: 1rem;
      }
    }
  }
  &:not(.nav) {
    max-width: 960px;
  }
  &.nav {
    ${theme.above.md} {
      .main-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        > aside {
          padding-top: 1rem;
          width: 20%;
        }
        > article {
          width: 78%;
        }
      }
    }
  }
`;

const ContentPage = ({ page, result }) => {
  const displayNav = shouldDisplayNavigation(page);
  if (!page)
    return (
      <Wrapper>
        <LoadingLine heightPx={27} widthRem={15} />
        <LoadingLine
          heightPx={14}
          widthRem={30}
          randomizeWidthBy={10}
          count={10}
          className={css`
            margin-bottom: 12px;
          `}
        />
      </Wrapper>
    );

  return (
    <Above breakpoint="md">
      {(matches) => (
        <Wrapper className={`${displayNav ? 'nav' : ''}`}>
          <div className="main-content">
            {page && displayNav && matches && (
              <aside>
                <SubNavigation page={page} />
              </aside>
            )}
            <article>
              <header>
                <BreadcrumbsWrapper
                  parents={result.data?.route?.parents || []}
                  breadcrumbs={result.data?.route?.breadcrumbs || []}
                />
                <h1>
                  <BackArrow parents={result.data?.route?.parents || []} />
                  {page.name}
                </h1>
                {displayNav && !matches && <SubPages page={page} />}
              </header>
              <ContentRender data={page.data} />
              <div className="content-wrapper">
                {page.mainHeader === 'faq' ? (
                  <FaqPage page={page} />
                ) : (
                  <>
                    <TextContent content={page.content} />
                  </>
                )}
              </div>
            </article>
          </div>
        </Wrapper>
      )}
    </Above>
  );
};

export default ContentPage;
